var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumTopicTooling = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#481C6A",
    d: "M32.57 33.768a.5.5 0 0 0 .004.703l6.793 6.793a.5.5 0 0 0 .71-.004l1.94-1.985a.5.5 0 0 0-.005-.703L35.22 31.78a.5.5 0 0 0-.71.004zm4.304-6.146c-.369 0-.76-.036-1.107-.13a.57.57 0 0 0-.556.13L21.565 41.207a.5.5 0 0 1-.706 0l-1.931-1.931a.5.5 0 0 1 0-.708l8.556-8.544a.5.5 0 0 0 0-.706l-1.511-1.52a.5.5 0 0 0-.703-.006l-.197.191a.5.5 0 0 1-.697 0l-.616-.599a.5.5 0 0 0-.848.359v2.184a.5.5 0 0 1-.147.354l-.373.373a.5.5 0 0 1-.709-.002l-3.697-3.74a.5.5 0 0 1 .002-.704l.377-.377a.5.5 0 0 1 .354-.147h2.104a.5.5 0 0 0 .355-.852l-.553-.557a.5.5 0 0 1 .002-.705l4.097-4.098a3.72 3.72 0 0 1 4.904-.326c.217.167.217.483.026.68l-1.946 1.991a.5.5 0 0 0 .006.704l1.054 1.047a.5.5 0 0 1 .001.709l-.178.178a.5.5 0 0 0 .001.708l1.523 1.514a.5.5 0 0 0 .712-.007l1.692-1.748a.57.57 0 0 0 .122-.55 4.1 4.1 0 0 1-.142-1.088c0-2.462 1.95-4.4 4.375-4.4q.755 0 1.398.246c.304.115.353.503.123.734l-2.53 2.53a.5.5 0 0 0 0 .706l1.168 1.168a.5.5 0 0 0 .707 0l2.53-2.53c.23-.23.619-.181.735.123.163.425.244.887.244 1.423 0 2.4-1.937 4.338-4.375 4.338"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumTopicTooling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-topic-tooling.30e88f3088330fb48c89b8b5ea385779.svg";